import { User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Badge } from "../ui/badge";

export const ProfileSection = ({ user }) => (
  <Card className="card-surface" data-testid="profile-card">
    <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
      <div className="flex items-center gap-3">
        <User className="w-5 h-5" style={{ color: 'var(--t-text-muted)' }} />
        <div>
          <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
            Profile
          </CardTitle>
          <CardDescription style={{ color: 'var(--t-text-muted)' }}>Your account information</CardDescription>
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-5">
      <div className="flex items-center gap-4 mb-6">
        {user?.picture ? (
          <img src={user.picture} alt={user.name} className="w-16 h-16 rounded-full border-2" style={{ borderColor: 'var(--t-border)' }} />
        ) : (
          <div className="w-16 h-16 rounded-full flex items-center justify-center text-white text-xl font-medium" style={{ background: 'var(--t-primary)' }}>
            {user?.name?.charAt(0)}
          </div>
        )}
        <div>
          <p className="text-lg font-semibold" style={{ color: 'var(--t-text)' }}>{user?.name}</p>
          <p className="text-sm" style={{ color: 'var(--t-text-muted)' }}>{user?.email}</p>
          <Badge className="mt-1" style={{ background: 'var(--t-primary)', color: '#fff', opacity: 0.9 }}>
            {user?.role === "super_admin" ? "Admin" : "Coordinator"}
          </Badge>
        </div>
      </div>
    </CardContent>
  </Card>
);
